(ns dashboard.demo-cartier
  (:require
   [malli.core :as mc]
   [malli.transform :as mt]
   [malli.generator :as mg]
   [dashboard.utils :refer [index-by]]
   ["date-fns" :refer
    [getDaysInMonth setDate format isSaturday isSunday addMonths subMonths
     isSameDay isToday isBefore eachDayOfInterval setYear setMonth endOfMonth
     startOfWeek endOfWeek startOfMonth getMonth parseISO]]))

;; Data for the Cartier Demo

(def ShiftPattern
  [:map
   [:id :uuid]
   [:symbol
    [:enum ["M" "希" "有" "研" "-" "1" "2" "3"]]]
   [:wimsFormat
    string?]
   [:description :string]
   [:hours
    [:float
     {:min 0.0 :max 24.0}]]
   [:startTime string?]
   [:endTime string?]])

(def Team
  [:map
   [:id :uuid]
   [:name string?]
   [:color string?]])

(def Staff
  [:map
   [:id :uuid]
   [:staffId
    {:gen/elements [35381 124090 125508 48575 17267 25119 17261 17416 30230
                    103738 120050 105674 121413 74316 118658 27781 88368 66832
                    27778 48576 49458 147942 17265 92485 88369 129551 131272]}
    number?]
   [:firstName
    {:gen/elements ["ロミー" "齊藤" "森" "河本" "原" "松田" "柴田" "吉田" "小川" "浜田"
                    "大川" "ヤーピン" "久嶋" "仲野" "西口" "平田" "岩田" "シャルル" "中村"
                    "ドワイヤー" "戸部" "青山" "荒井" "白井" "石関" "鄒" "安川" "大井"
                    "粟田" "永田" " 南" "高瀬" "星川" "小林" "藤村" "矢野" "高橋知"
                    "川次" "河端" "呉" "佐々木" "高安" "橋本" "木戸" "山嵜" "梅村" "高橋真"]}
    string?]
   [:firstNameJp
    {:gen/elements ["ロミー" "齊藤" "森" "河本" "原" "松田" "柴田" "吉田" "小川" "浜田"
                    "大川" "ヤーピン" "久嶋" "仲野" "西口" "平田" "岩田" "シャルル" "中村"
                    "ドワイヤー" "戸部" "青山" "荒井" "白井" "石関" "鄒" "安川" "大井"
                    "粟田" "永田" " 南" "高瀬" "星川" "小林" "藤村" "矢野" "高橋知"
                    "川次" "河端" "呉" "佐々木" "高安" "橋本" "木戸" "山嵜" "梅村" "高橋真"]}
    string?]
   [:lastName
    {:gen/elements ["ロミー" "齊藤" "森" "河本" "原" "松田" "柴田" "吉田" "小川" "浜田"
                    "大川" "ヤーピン" "久嶋" "仲野" "西口" "平田" "岩田" "シャルル" "中村"
                    "ドワイヤー" "戸部" "青山" "荒井" "白井" "石関" "鄒" "安川" "大井"
                    "粟田" "永田" " 南" "高瀬" "星川" "小林" "藤村" "矢野" "高橋知"
                    "川次" "河端" "呉" "佐々木" "高安" "橋本" "木戸" "山嵜" "梅村" "高橋真"]}
    string?]
   [:lastNameJp
    {:gen/elements ["ロミー" "齊藤" "森" "河本" "原" "松田" "柴田" "吉田" "小川" "浜田"
                    "大川" "ヤーピン" "久嶋" "仲野" "西口" "平田" "岩田" "シャルル" "中村"
                    "ドワイヤー" "戸部" "青山" "荒井" "白井" "石関" "鄒" "安川" "大井"
                    "粟田" "永田" " 南" "高瀬" "星川" "小林" "藤村" "矢野" "高橋知"
                    "川次" "河端" "呉" "佐々木" "高安" "橋本" "木戸" "山嵜" "梅村" "高橋真"]}
    string?]
   [:profile_picture_url
    {:gen/elements
     ["https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1590086782792-42dd2350140d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      "https://images.unsplash.com/photo-1507101105822-7472b28e22ac?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"]}
    string?]
   [:email
    {:gen/elements ["demo@cartier.com" "demo@cartier.com"]}
    string?]
   [:shift_preferences
    map?]
   [:team
    {:gen/elements ["SALES" "MGR"]}
    string?]])

(def raw-real-staffs
  [{:externalId 35381,
    :firstName "Hiroshi",
    :lastNameJp "佐藤",
    :reportToId "",
    :id "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :lastName "Sato",
    :firstNameJp "寛",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-manager",
    :titleId "ﾌﾞﾃｨｯｸ･ﾏﾈｰｼﾞｬｰ"}
   {:externalId 124090,
    :firstName "Hatsue",
    :lastNameJp "齊藤",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :lastName "Saito",
    :firstNameJp "初枝",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｱｼｽﾀﾝﾄ･ﾌﾞﾃｨｯｸ･ﾏﾈｰｼﾞｬｰ"}
   {:externalId 125508,
    :firstName "Yoshinori",
    :lastNameJp "金子",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :lastName "Kaneko",
    :firstNameJp "喜則",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｱｼｽﾀﾝﾄ･ﾌﾞﾃｨｯｸ･ﾏﾈｰｼﾞｬｰ"}
   {:externalId 17267,
    :firstName "Mika",
    :lastNameJp "田中",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "b6ef1c9c-8030-4aaa-a97a-3aa6a0d00afb",
    :lastName "Tanaka",
    :firstNameJp "美加",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｴｸﾞｾﾞｸﾃｨﾌﾞ"}
   {:externalId 25119,
    :firstName "Masahiro",
    :lastNameJp "伊藤",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "bbca8c58-2307-40b7-9ab2-37ccaad1915e",
    :lastName "Ito",
    :firstNameJp "順啓",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｴｸﾞｾﾞｸﾃｨﾌﾞ"}
   {:externalId 17261,
    :firstName "Takenori",
    :lastNameJp "五十嵐",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "7f7c39ba-0bfe-4063-b542-503efeb14c91",
    :lastName "Igarashi",
    :firstNameJp "剛徳",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 17265,
    :firstName "Ryoko",
    :lastNameJp "岡村",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "e125114e-c24a-492f-9145-858c79133bb6",
    :lastName "Okamura",
    :firstNameJp "糧子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 17416,
    :firstName "Minako",
    :lastNameJp "髙岸",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "096cb976-5145-415b-842d-07f95563c01b",
    :lastName "Takagishi",
    :firstNameJp "美奈子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 30230,
    :firstName "Tomomi",
    :lastNameJp "加藤",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "942e3251-602a-448a-a30d-cd542b4ddb08",
    :lastName "Kato",
    :firstNameJp "友美",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 103738,
    :firstName "Saori",
    :lastNameJp "松崎",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "b273c545-9772-4abe-b47c-f7aaafe4e64a",
    :lastName "Matsuzaki",
    :firstNameJp "佐織",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 120050,
    :firstName "Kazuya",
    :lastNameJp "山内",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "01e6da67-6ab2-4ed0-8b93-d646cd17cd40",
    :lastName "Yamauchi",
    :firstNameJp "和也",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 27778,
    :firstName "Kaori",
    :lastNameJp "今井",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "177cc6be-552c-45cb-a6da-be832433931e",
    :lastName "Imai",
    :firstNameJp "香",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｸﾗｲｱﾝﾄｻｰﾋﾞｽ･ｱﾄﾞﾊﾞｲｻﾞｰ"}
   {:externalId 48576,
    :firstName "Hitomi",
    :lastNameJp "布施",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "52ead81c-7064-4553-b6a2-36c8ea0af996",
    :lastName "Fuse",
    :firstNameJp "瞳",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｸﾗｲｱﾝﾄｻｰﾋﾞｽ･ｱﾄﾞﾊﾞｲｻﾞｰ"}
   {:externalId 173191,
    :firstName "Yuichi",
    :lastNameJp "長谷川",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "ec1bb16a-44a6-4607-8ab7-a8d26e0be9ea",
    :lastName "Hasegawa",
    :firstNameJp "裕一",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｸﾗｲｱﾝﾄｻｰﾋﾞｽ･ｱﾄﾞﾊﾞｲｻﾞｰ"}
   {:externalId 48575,
    :firstName "Yang",
    :lastNameJp "齊藤",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "f609469e-7e98-4f01-8b0e-f6ba25589ae9",
    :lastName "Saito",
    :firstNameJp "楊",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｴｸﾞｾﾞｸﾃｨﾌﾞ"}
   {:externalId 81552,
    :firstName "Chihiro",
    :lastNameJp "竹井",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "a60475da-dddc-43b2-9cd8-a3fff3093478",
    :lastName "Takei",
    :firstNameJp "千尋",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 88369,
    :firstName "Karin",
    :lastNameJp "田中",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "fc772204-3f62-4335-9677-2e3a919ea607",
    :lastName "Tanaka",
    :firstNameJp "果林",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 92485,
    :firstName "Yumi",
    :lastNameJp "川次",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "f4d17e51-f41f-4f1a-988f-c833490024f3",
    :lastName "Kawatsugu",
    :firstNameJp "由美",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 105674,
    :firstName "Moyoko",
    :lastNameJp "金崎",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "725dee58-5315-45c9-a457-05f47c045886",
    :lastName "Kanazaki",
    :firstNameJp "百代子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 107289,
    :firstName "Ryoko",
    :lastNameJp "海部",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "84e610a0-0786-4327-bbd3-d06ae288cb75",
    :lastName "Kaibe",
    :firstNameJp "瞭子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 121413,
    :firstName "Aiko",
    :lastNameJp "岡田",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "42a71672-4310-477f-8265-21afd18185bd",
    :lastName "Okada",
    :firstNameJp "愛子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 74316,
    :firstName "Kohei",
    :lastNameJp "櫻井",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "44e7c5cd-fba4-49f7-ada1-f0e188af0fec",
    :lastName "Sakurai",
    :firstNameJp "洸平",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 118658,
    :firstName "Shoko",
    :lastNameJp "中村",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "b3711ba2-2644-457c-ac84-68242dcbe279",
    :lastName "Nakamura",
    :firstNameJp "翔子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 129551,
    :firstName "Nozomi",
    :lastNameJp "山川",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "a29a38b0-1764-4904-9fbe-9c54ed007845",
    :lastName "Yamakawa",
    :firstNameJp "希",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 131272,
    :firstName "Hidetaka",
    :lastNameJp "高山",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "704e8a3d-b7ba-4e71-9b0d-e0edcca8da71",
    :lastName "Takayama",
    :firstNameJp "英敬",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 179469,
    :firstName "Nagaoka",
    :lastNameJp "永岡",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "e4af4921-20d2-40ff-827e-3a82bed2c741",
    :lastName "Mariko",
    :firstNameJp "まり子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 181040,
    :firstName "Kenshi",
    :lastNameJp "陳",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "b48326ce-660b-4b23-8ccf-a0acfb6832de",
    :lastName "Chin",
    :firstNameJp "建至",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 49458,
    :firstName "Nami",
    :lastNameJp "松岡",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "e6252df5-b741-45af-86be-6634ef557428",
    :lastName "Matsuoka",
    :firstNameJp "奈美",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｸﾗｲｱﾝﾄｻｰﾋﾞｽ･ｱﾄﾞﾊﾞｲｻﾞｰ"}
   {:externalId 147942,
    :firstName "Yuki",
    :lastNameJp "佐藤",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "d325d829-96c2-49b5-b8d8-ba0bafa387ba",
    :lastName "Sato",
    :firstNameJp "友紀",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｸﾗｲｱﾝﾄｻｰﾋﾞｽ･ｱﾄﾞﾊﾞｲｻﾞｰ"}
   {:externalId 66832,
    :firstName "Yasuhiko",
    :lastNameJp "沼部",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "762d56c2-7951-4187-9714-7265b1428622",
    :lastName "Numabe",
    :firstNameJp "泰彦",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｺﾝｼｪﾙｼﾞｭ / ﾌﾞﾃｨｯｸ ｱｼｽﾀﾝﾄ"}
   {:externalId 88368,
    :firstName "Kaori",
    :lastNameJp "渡邉",
    :reportToId "69b250f7-61bf-49d5-bce2-9ce69d05f9a7",
    :id "89c3a0ff-32d3-456e-8647-6f5851bad1e0",
    :lastName "Watanabe",
    :firstNameJp "香織",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ﾌﾞﾃｨｯｸ･ｵﾍﾟﾚｰｼｮﾝｽﾞ･ｼﾆｱ･ｱｿｼｴｲﾄ"}
   {:externalId 27781,
    :firstName "Takiko",
    :lastNameJp "伊佐",
    :reportToId "76748d6a-cfab-4ea8-b1b2-071219dc468c",
    :id "cb15eb57-c10a-4e0e-9c89-9ceedcbcd009",
    :lastName "Isa",
    :firstNameJp "たき子",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ﾌﾞﾃｨｯｸ･ｵﾍﾟﾚｰｼｮﾝｽﾞ･ﾁｰﾌ"}
   {:externalId 46993,
    :firstName "Mami",
    :lastNameJp "浦部",
    :reportToId "3d6c5363-ba93-4a47-b97d-9f124e42ad6a",
    :id "e53299c2-edbe-4fb2-9253-66ddd4f4b1dd",
    :lastName "Urabe",
    :firstNameJp "麻美",
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ﾌﾞﾃｨｯｸ･ｵﾍﾟﾚｰｼｮﾝｽﾞ･ﾏﾈｰｼﾞｬｰ"}
   {:externalId 17384,
    :firstName "Kenji",
    :lastNameJp "松浦",
    :reportToId "",
    :id "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :lastName "Matsuura",
    :firstNameJp "健志",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-manager",
    :titleId "ﾌﾞﾃｨｯｸ･ﾏﾈｰｼﾞｬｰ"}
   {:externalId 24255,
    :firstName "Rikio",
    :lastNameJp "大黒",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :lastName "Daikoku",
    :firstNameJp "力男",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｱｼｽﾀﾝﾄ･ﾌﾞﾃｨｯｸ･ﾏﾈｰｼﾞｬｰ"}
   {:externalId 17139,
    :firstName "Mayumi",
    :lastNameJp "中田",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "dfaaf0e4-7645-40cd-a1fb-c47225e7670d",
    :lastName "Nakata",
    :firstNameJp "真由美",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 17312,
    :firstName "Yuka",
    :lastNameJp "岡本",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "4825f5b9-5563-4d93-a043-3602a7463be1",
    :lastName "Okamoto",
    :firstNameJp "由加",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 52939,
    :firstName "Keiko",
    :lastNameJp "横山",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "071f5303-6e8c-418d-822f-d5fa7c267e5c",
    :lastName "Yokoyama",
    :firstNameJp "圭子",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 66838,
    :firstName "Eri",
    :lastNameJp "森井",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "06a32c7e-a0d8-4f42-a305-0aa6e1a9fa76",
    :lastName "Morii",
    :firstNameJp "苗里",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 112942,
    :firstName "Akihiro",
    :lastNameJp "冨田",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "e93b985d-a7b3-4e04-97bc-7f961f2afc69",
    :lastName "Tomita",
    :firstNameJp "晃弘",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 57172,
    :firstName "Yuko",
    :lastNameJp "冨吉",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "a0a9b66b-af8e-4971-9d86-70746aca434e",
    :lastName "Tomiyoshi",
    :firstNameJp "優子",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 105745,
    :firstName "Taishi",
    :lastNameJp "渡邉",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "027a6910-db51-4063-82c6-a0229ea0fe50",
    :lastName "Watanabe",
    :firstNameJp "大志",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 115874,
    :firstName "Hiromi",
    :lastNameJp "的場",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "383b1491-5bb0-4369-ab91-7b4550eb69a5",
    :lastName "Matoba",
    :firstNameJp "博美",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 134329,
    :firstName "Masao",
    :lastNameJp "大森",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "59cc095c-042c-40d1-bcb4-06d366b9bdc1",
    :lastName "Omori",
    :firstNameJp "真生",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 123105,
    :firstName "Ran",
    :lastNameJp "杉山",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "e1bed32e-ddbb-4ba5-93e1-0847e02cb12b",
    :lastName "Sugiyama",
    :firstNameJp "蘭",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 125327,
    :firstName "Tomohiro",
    :lastNameJp "森",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "e08ba010-fd3a-40af-a1aa-b5cdb9733c57",
    :lastName "Mori",
    :firstNameJp "智洋",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 144520,
    :firstName "Misa",
    :lastNameJp "澤崎",
    :reportToId "18715b16-4a9e-489d-9a76-21f1ff2928e0",
    :id "9719a14d-e987-4416-9bad-474edbec477a",
    :lastName "Sawasaki",
    :firstNameJp "未沙",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ｼﾞｭﾆｱ･ｾｰﾙｽ･ｱｿｼｴｲﾄ"}
   {:externalId 39700,
    :firstName "Satoka",
    :lastNameJp "奥川",
    :reportToId "20e948d5-2c4e-4229-9caa-7ac83add2cd7",
    :id "e09f2467-e224-4091-ac94-bc317a6852c5",
    :lastName "Okugawa",
    :firstNameJp "智可",
    :spaceId "8cd0febe-81eb-4959-8f75-ae24a16263af",
    :roleId "store-staff",
    :titleId "ﾌﾞﾃｨｯｸ･ｵﾍﾟﾚｰｼｮﾝｽﾞ･ｼﾆｱ･ｱｿｼｴｲﾄ"}])

(def real-staffs
  (->> raw-real-staffs
       (map #(assoc %
                    :locale :ja
                    :externalId (str (:externalId %))
                    :auth0UserId "none"
                    :organizationId "1cd0febe-81eb-4959-8f75-ae24a16263af"))))

(def Shift
  [:map
   [:id :uuid]
   [:spaceId :uuid]
   [:date inst?]
   [:tags [:set keyword?]]
   [:user string?]
   [:pattern string?]
   [:comments string?]])

(def teams
  [{:id (uuid "6cd0febe-81eb-4959-8f75-ae24a16263af")
    :name "SALES"
    :color "blue"
    :space "space-demo"}
   {:id (uuid "6cd0febe-81eb-4959-8f75-ae24a16263ag")
    :name "MGR"
    :color "red"
    :space "space-demo"}])

#_(def staffs
    (concat
     [{:id (uuid "6cd0febe-81eb-4959-8f75-ae24a16263af")
       :firstName "Yasuhiro"
       :lastName "Yoshida"
       :firstNameJp "康弘"
       :lastNameJp "吉田"
       :title "Store Manager"
       :roleId "store-manager"
       :created_at "2022-05-05T14:07:30.364-00:00"
       :updated_at "2022-05-15T14:07:30.364-00:00"
       :profile_picture_url "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
       :team "MGR"
       :shiftPreferences {}
       :reportToId nil
       :email "yasuhiro.yoshida@cartier.com"}
      {:id (uuid "4a52e4b3-108f-4952-bec8-1a6929d69273")
       :firstName "Kenji"
       :lastName "Toyama"
       :firstNameJp "健二"
       :lastNameJp "遠山"
       :title "Store Staff"
       :roleId "store-staff"
       :created_at "2022-05-05T14:07:30.364-00:00"
       :updated_at "2022-05-15T14:07:30.364-00:00"
       :profile_picture_url "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
       :team "SALES"
       :shiftPreferences {}
       :reportToId nil
       :email "kenji.toyama@cartier.com"}]
     (mg/sample Staff {:size 20})))

(def patterns
  [{:description "",
    :wimsFormat "D201-F",
    :startTime "09:30",
    :symbol "F",
    :endTime "20:30",
    :isDayOff false,
    :id "a80af251-a7fd-48b9-ad39-5dafd1881b75",
    :hours 9.5}
   {:description "",
    :wimsFormat "D201-E",
    :startTime "09:30",
    :symbol "E",
    :endTime "18:30",
    :isDayOff false,
    :id "bd60f7e1-3ac9-4e8c-93d8-0721a8341852",
    :hours 7.5}
   {:description "",
    :wimsFormat "D201-L",
    :startTime "11:30",
    :symbol "L",
    :endTime "20:30",
    :isDayOff false,
    :id "237613e0-6ff5-47a9-962c-31b1c87e738d",
    :hours 7.5}
   {:description "",
    :wimsFormat "D201-M",
    :startTime "10:30",
    :symbol "M",
    :endTime "19:30",
    :isDayOff false,
    :id "3283f936-51ab-4f64-8371-59a6bd605040",
    :hours 7.5}
   {:description "",
    :wimsFormat "D201-E1",
    :startTime "09:30",
    :symbol "E1",
    :endTime "16:30",
    :isDayOff false,
    :id "63f8e671-4ee5-4833-aca4-b31455f57686",
    :hours 5.5}
   {:description "",
    :wimsFormat "D201-E2",
    :startTime "10:00",
    :symbol "E2",
    :endTime "17:00",
    :isDayOff false,
    :id "ec93a655-642b-416e-931e-29b7c8ce72c8",
    :hours 5.5}
   {:description "",
    :wimsFormat "D201-L1",
    :startTime "11:00",
    :symbol "L1",
    :endTime "12:00",
    :isDayOff false,
    :id "cbf2c0ce-0923-4edd-941f-ca5ed6c78680",
    :hours 7.5}
   {:description "",
    :wimsFormat "休",
    :startTime nil,
    :symbol "休",
    :endTime nil,
    :isDayOff true,
    :id "b5a82054-f14c-4467-8770-cdc583a4619b",
    :hours 0}
   {:description "",
    :wimsFormat "D201-外出",
    :startTime nil,
    :symbol "外出",
    :endTime nil,
    :isDayOff false,
    :id "c518c542-97a8-4f42-9472-dcf0ed6dfde5",
    :hours 7.5}])

(def tags
  [{:id "6cd0febe-81eb-4959-8f75-ae24a16263af"
    :symbol "希"
    :description "Requested by staff"
    :color "red"}
   {:id "4a52e4b3-108f-4952-bec8-1a6929d69273"
    :symbol "参"
    :description "Attendance"
    :color "blue"}
   {:id "4a52e4b4-108f-4952-bec8-1a6929d69274"
    :symbol "ガ"
    :description "Gaisho"
    :color "yellow"}
   {:id "4a52e4b5-108f-4952-bec8-1a6929d69275"
    :symbol "1F"
    :description ""
    :color "green"}
   {:id "4a52e4b5-108f-4952-bec8-1a6929d69276"
    :symbol "2F"
    :description ""
    :color "green"}
   {:id "4a52e4b5-108f-4952-bec8-1a6929d69277"
    :symbol "3F"
    :description ""
    :color "green"}
   {:id "4a52e4b5-108f-4952-bec8-1a6929d69278"
    :symbol "4F"
    :description ""
    :color "green"}])

(def spaces
  [{:id "7cd0febe-81eb-4959-8f75-ae24a16263af"
    :externalId "550201"
    :organizationId "1cd0febe-81eb-4959-8f75-ae24a16263af"
    :name "Shinjuku Isetan"
    :nameJp "新宿伊勢丹"
    :timezone "Asia/Tokyo"
    :isActive true
    :shiftPatterns patterns
    :shiftTags tags}
   {:id "8cd0febe-81eb-4959-8f75-ae24a16263af"
    :externalId "550258"
    :organizationId "1cd0febe-81eb-4959-8f75-ae24a16263af"
    :name "Shinsaibashi Daimaru"
    :nameJp "心斎橋大丸"
    :timezone "Asia/Tokyo"
    :isActive true
    :shiftPatterns []
    :shiftTags []}
   {:id (uuid "6cd0febe-81eb-4959-8f75-ae24a16263a1")
    :externalId nil
    :name "Takashimaya Shinjuku"
    :nameJp "高島屋新宿店"
    :timezone "Asia/Tokyo"
    :address "5 Chome-24-2 Sendagaya Shibuya City, Tokyo 151-8580"
    :isActive false
    :shiftPatterns []
    :shiftTags []}
   {:id (uuid "6cd0febe-81eb-4959-8f75-ae24a16263a2")
    :externalId nil
    :name "Ginza"
    :nameJp "銀座"
    :timezone "Asia/Tokyo"
    :address "2 Chome-6-12 Ginza Chuo City, Tokyo 104-0061"
    :isActive false
    :shiftPatterns []
    :shiftTags []}])

(def shifts
  (->> real-staffs
       (map (fn [staff]
              (hash-map
               (:id staff)
               (into {}
                     (->> (eachDayOfInterval
                           (clj->js
                            {:start (->> (setMonth (setYear (js/Date.) 2022) 6)
                                         (startOfMonth)
                                         (startOfWeek))
                             :end (->> (setMonth (setYear (js/Date.) 2022) 8)
                                       (endOfMonth)
                                       (endOfWeek))}))

                          (map (fn [day]
                                 (hash-map
                                  (format day "yyyy-MM-dd")
                                  {:id (random-uuid)
                                   :spaceId (uuid "7cd0febe-81eb-4959-8f75-ae24a16263af")
                                   :userId (:id staff)
                                   :date (format day "yyyy-MM-dd")
                                   :comment ""
                                   :pattern (rand-nth (concat (map :symbol patterns) (repeat 5 "休")))
                                   :tags (into #{} (take (rand-nth [1 2 0 0 0 0 0]) (shuffle (map :symbol tags))))})))
                          (merge))))))
       (merge)
       (map vals)
       (flatten)
       (map vals)
       (flatten)
       (into [])))

;; Demo DB to be injected at the start of the application

(def personas
  {:store-manager
   {:id (uuid "6cd0febe-81eb-4959-8f75-ae24a16263af")
    :firstName "Yasuhiro"
    :lastName "Yoshida"
    :firstNameJp "康弘"
    :lastNameJp "吉田"
    :title "Store Manager"
    :roleId "store-manager"
    :created_at "2022-05-05T14:07:30.364-00:00"
    :updated_at "2022-05-15T14:07:30.364-00:00"
    :profile_picture_url "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    :team "MGR"
    :spokenLanguages #{"en" "ja"}}
   :store-staff
   {:id (uuid "4a52e4b3-108f-4952-bec8-1a6929d69273")
    :firstName "Kenji"
    :lastName "Toyama"
    :firstNameJp "健二"
    :lastNameJp "遠山"
    :title "Store Staff"
    :roleId "store-staff"
    :created_at "2022-05-05T14:07:30.364-00:00"
    :updated_at "2022-05-15T14:07:30.364-00:00"
    :profile_picture_url "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    :team "SALES"
    :spokenLanguages #{"ja"}}
   :retail-manager
   {:id (uuid "dcfb7ef4-7aaa-427d-96d4-114b2f0042e4")
    :firstName "Tsumugi"
    :lastName "Yagi"
    :firstNameJp "紬"
    :lastNameJp "八木"
    :title "Retail Manager"
    :roleId "retail-manager"
    :created_at "2022-05-05T14:07:30.364-00:00"
    :updated_at "2022-05-15T14:07:30.364-00:00"
    :profile_picture_url "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    :spokenLanguages #{"en" "ja"}}
   :admin
   {:id (uuid "97bda55b-6175-4c39-9e04-7c0205c709dc")
    :firstName "John"
    :lastName "Doe"
    :firstNameJp "John"
    :lastNameJp "Doe"
    :title "Admin"
    :roleId "admin"
    :created_at "2022-05-05T14:07:30.364-00:00"
    :updated_at "2022-05-15T14:07:30.364-00:00"
    :profile_picture_url "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    :spokenLanguages #{"en" "ja"}}})

;; Events

(def event-tags
  [{:id "mandatory"
    :name "Mandatory"
    :description ""
    :color "red"}
   {:id "digital"
    :name "Digital"
    :description ""
    :color "blue"}
   {:id "retail"
    :name "Retail"
    :description ""
    :color "yellow"}])

(def event-status
  [{:id "draft"
    :name "Draft"
    :color "red"}
   {:id "submitted"
    :name "Submitted"
    :color "yellow"}
   {:id "requested"
    :name "Requested"
    :color "orange"}
   {:id "approved"
    :name "Approved"
    :color "green"}])

(def calendars
  [{:id "8cd0febe-81eb-4959-8f75-ae24a16263af"
    :organizationId "1cd0febe-81eb-4959-8f75-ae24a16263af"
    :name "Company Events"
    :color "yellow"
    :spaceId "none"
    :userId "none"
    :eventTags event-tags
    :eventStatuses event-status}
   {:id "9cd0febe-81eb-4959-8f75-ae24a16263af"
    :organizationId "1cd0febe-81eb-4959-8f75-ae24a16263af"
    :name "Store Events"
    :color "blue"
    :spaceId "7cd0febe-81eb-4959-8f75-ae24a16263af"
    :userId "none"
    :eventTags []
    :eventStatuses []}])

(def events
  [{:id (str (random-uuid))
    :name "Bridal Week day 1"
    :date (format (setDate (js/Date.) 15) "yyyy-MM-dd")
    :startTime "10:00"
    :endTime "18:00"
    :locationId "5ac768a9-3c33-4c20-884e-f29cece52884"
    :calendarId (:id (first calendars))
    :statusId "requested"
    :tagIds #{}
    :attendees (->> (take (rand-int 10) (shuffle (map :id real-staffs)))
                    (mapv #(hash-map :userId (str %) :status (rand-nth [:pending :declined :accepted]))))}
   {:id (random-uuid)
    :name "Bridal Week day 2"
    :date (format (setDate (js/Date.) 16) "yyyy-MM-dd")
    :startTime "10:00"
    :endTime "17:30"
    :locationId "5ac768a9-3c33-4c20-884e-f29cece52884"
    :calendarId (:id (first calendars))
    :statusId "requested"
    :tagIds (into #{} [(rand-nth (map :id event-tags))])
    :attendees (->> (take (rand-int 10) (shuffle (map :id real-staffs)))
                    (mapv #(hash-map :userId (str %) :status (rand-nth [:pending :declined :accepted]))))}
   {:id (str (random-uuid))
    :name "Kyoto HJ"
    :date (format (setDate (js/Date.) 22) "yyyy-MM-dd")
    :startTime "10:00"
    :endTime "17:30"
    :locationId "5ac768a9-3c33-4c20-884e-f29cece52884"
    :calendarId (:id (first calendars))
    :statusId "requested"
    :tagIds (into [] (into #{} [(rand-nth (map :id event-tags))]))
    :attendees (->> (take (rand-int 10) (shuffle (map :id real-staffs)))
                    (mapv #(hash-map :userId (str %) :status (rand-nth [:pending :declined :accepted]))))}
   {:id (str (random-uuid))
    :name "Kyoto HJ"
    :date (format (setDate (js/Date.) 30) "yyyy-MM-dd")
    :startTime "10:00"
    :endTime "17:30"
    :locationId "5ac768a9-3c33-4c20-884e-f29cece52884"
    :calendarId (:id (first calendars))
    :statusId "approved"
    :tagIds []
    :attendees (->> (take (rand-int 20) (shuffle (map :id real-staffs)))
                    (mapv #(hash-map :userId (str %) :status (rand-nth [:pending :declined :accepted]))))}
   {:id (random-uuid)
    :name "Kyoto HJ"
    :date (format (setDate (js/Date.) 31) "yyyy-MM-dd")
    :startTime "10:00"
    :endTime "17:30"
    :locationId "175c8b66-4c0c-4810-9b91-6f8170c0b72d"
    :calendarId (:id (first calendars))
    :statusId "approved"
    :tagIds []
    :attendees (->> (take (rand-int 20) (shuffle (map :id real-staffs)))
                    (mapv #(hash-map :userId % :status (rand-nth [:pending :declined :accepted]))))}])

(def demo-db
  {:logo "img/cartier_logo.svg"
   :logo-reversed "img/cartier_logo_reversed.svg"
   :company-name "Cartier"
   :organization {:id (uuid "1cd0febe-81eb-4959-8f75-ae24a16263af")
                  :name "Cartier"
                  :url "https://cartier.myboutique.dev"}
   :roles [{:id "store-manager"
            :name "Store Manager"
            :permissions [{:resource :calendars
                           :action :edit}
                          {:resource :shifts
                           :action :edit}
                          {:resource :settings/profile
                           :action :edit}
                          {:resource :settings/shifts
                           :action :edit}
                          {:resource :settings/teams
                           :action :edit}]}
           {:id "store-staff"
            :name "Store Staff"
            :permissions [{:resource :calendars
                           :action :view}
                          {:resource :shifts
                           :action :view}
                          {:resource :settings/profile
                           :action :edit}
                          {:resource :settings/shifts
                           :action :view}]}
           {:id "retail-manager"
            :name "Retail Training"
            :permissions [{:resource :calendars
                           :action :edit}
                          {:resource :shifts
                           :action :view}
                          {:resource :settings/profile
                           :action :edit}
                          {:resource :settings/calendars
                           :action :edit}]}
           {:id "admin"
            :name "Admin"
            :permissions [{:resource :calendars
                           :action :edit}
                          {:resource :shifts
                           :action :edit}
                          {:resource :settings/teams
                           :action :edit}
                          {:resource :settings/profile
                           :action :edit}
                          {:resource :settings/calendars
                           :action :edit}
                          {:resource :settings/spaces
                           :action :edit}
                          {:resource :settings/shifts
                           :action :edit}
                          {:resource :settings/roles
                           :action :edit}
                          {:resource :settings/users
                           :action :edit}]}]
   :calendars calendars
   :teams teams
   :spaces spaces
   :selected {:space-id (str (:id (first spaces)))}
   :staffs (->> real-staffs)
   :space/shifts {"7cd0febe-81eb-4959-8f75-ae24a16263af" shifts}
   :events events
   :event-tags event-tags
   :event-status event-status})
